import {styled} from "@mui/material/styles";

// MUI components
import FaiButton from "../FaiButton";
import {ThemeInterface} from "../../assets/types/ThemeInterface";

interface OwnerState {
    variant: string;
    paginationSize: string | null;
    active: boolean;
}

interface StyledPaginationProps {
    theme?: ThemeInterface;
    ownerState: OwnerState;
}

export default styled(FaiButton)<StyledPaginationProps>(({theme, ownerState}) => {
    const {borders, functions, typography, palette} = theme;
    const {variant, paginationSize, active} = ownerState;

    const {borderColor} = borders;
    const {pxToRem} = functions;
    const {fontWeightRegular, size: fontSize} = typography;
    // @ts-ignore
    const {light} = palette;

    // width, height, minWidth and minHeight values
    let sizeValue = pxToRem(36);

    if (paginationSize === "small") {
        sizeValue = pxToRem(30);
    } else if (paginationSize === "large") {
        sizeValue = pxToRem(46);
    }

    return {
        borderColor: "#121212B2",
        margin: `0 ${pxToRem(2)}`,
        pointerEvents: active ? "none" : "auto",
        fontWeight: fontWeightRegular,
        fontSize: fontSize.sm,
        width: sizeValue,
        minWidth: sizeValue,
        height: sizeValue,
        minHeight: sizeValue,

        "&:hover, &:focus, &:active": {
            transform: "none",
            boxShadow: (variant !== "gradient" && variant !== "contained") && "none !important",
            opacity: "1 !important",
        },

        "&:hover": {
            backgroundColor: light.main,
            borderColor,
        },
    };
});
